/* GENERATED FROM apps-script.gs — DO NOT EDIT.
 * Rebuild with: node scripts/build-theme.mjs
 *
 * The same arithmetic the server invoices with, so the total on screen and the
 * total on the invoice cannot disagree. Contains no rates: a store's own rates
 * arrive in its sign-in response and never include any other tier's.
 */
var PORTAL_PRODUCTS = [
  { id: 'natural-bag',   flavour: 'Natural Almond',   label: '740 g bag',
    invoiceDescription: '740 g Natural Almond Protein Bag',  kind: 'bag', caseSize: 6 },
  { id: 'chocolate-bag', flavour: 'Chocolate Almond', label: '930 g bag',
    invoiceDescription: '930 g Chocolate Almond Protein Bag', kind: 'bag', caseSize: 6 },
  { id: 'vanilla-bag',   flavour: 'Creamy Vanilla',   label: '700 g bag',
    invoiceDescription: '700 g Vanilla Almond Protein Bag',   kind: 'bag', caseSize: 6 },
  { id: 'natural-box',   flavour: 'Natural Almond',   label: '20-pouch box',
    invoiceDescription: '20-pouch Natural Almond Box',        kind: 'box', caseSize: 1 },
  { id: 'chocolate-box', flavour: 'Chocolate Almond', label: '20-pouch box',
    invoiceDescription: '20-pouch Chocolate Almond Box',      kind: 'box', caseSize: 1 }
];

function _round2(n) {
  return Math.round((n + Number.EPSILON) * 100) / 100;
}

function _rateForKind(profile, kind) {
  return kind === 'bag' ? profile.bagRate : profile.boxRate;
}

function _freightFor(rule, units, province) {
  if (rule.mode === 'included') {
    return { shipping: 0, shippingReason: rule.reason };
  }
  if (units > rule.freeOverUnits) {
    return { shipping: 0, shippingReason: 'Free over ' + rule.freeOverUnits + ' units' };
  }
  if (units === 0) {
    return { shipping: 0, shippingReason: 'Add products to see freight' };
  }
  var prov = String(province || '').trim().toUpperCase();
  if (prov && prov === rule.province) {
    return { shipping: rule.inProvince, shippingReason: 'Within ' + rule.province };
  }
  return {
    shipping: rule.outOfProvince,
    shippingReason: prov ? 'Outside ' + rule.province + ' (' + prov + ')'
                         : 'Outside ' + rule.province
  };
}

function _quote(profile, quantities, province) {
  var lines = [];
  var byId = {};
  PORTAL_PRODUCTS.forEach(function (p) { byId[p.id] = p; });

  PORTAL_PRODUCTS.forEach(function (product) {
    var raw = quantities ? quantities[product.id] : 0;
    var qty = Math.max(0, Math.floor(Number(raw) || 0));
    if (qty === 0) return;
    var rate = _rateForKind(profile, product.kind);
    lines.push({
      productId: product.id,
      description: product.invoiceDescription,
      kind: product.kind,
      qty: qty,
      rate: rate,
      amount: _round2(qty * rate)
    });
  });

  var bagUnits = 0, boxUnits = 0, subtotalRaw = 0;
  lines.forEach(function (l) {
    if (l.kind === 'bag') bagUnits += l.qty; else boxUnits += l.qty;
    subtotalRaw += l.amount;
  });
  var units = bagUnits + boxUnits;
  var subtotal = _round2(subtotalRaw);

  var freight = _freightFor(profile.freight, units, province);
  var value = _round2(subtotal + freight.shipping);
  var gst = _round2(value * profile.gstRate);
  var total = _round2(value + gst);

  var warnings = [];
  lines.forEach(function (line) {
    var product = byId[line.productId];
    if (product.caseSize > 1 && line.qty % product.caseSize !== 0) {
      warnings.push(product.flavour + ' ' + product.label + ': ' + line.qty +
        ' is not a full case of ' + product.caseSize + '.');
    }
  });

  // Minimum order quantity. Unlike the case warnings this one blocks the
  // order, so it is reported separately rather than as another warning.
  var belowMinimum = units > 0 && units < profile.minOrderUnits;
  var shortBy = belowMinimum ? profile.minOrderUnits - units : 0;

  return {
    lines: lines, units: units, bagUnits: bagUnits, boxUnits: boxUnits,
    subtotal: subtotal, shipping: freight.shipping,
    shippingReason: freight.shippingReason,
    value: value, gst: gst, total: total,
    warnings: warnings, isEmpty: lines.length === 0,
    minOrderUnits: profile.minOrderUnits,
    belowMinimum: belowMinimum, shortBy: shortBy
  };
}
